import { defineMessages } from "react-intl";

export default defineMessages({
  paypal: {
    id: "paymentMethods.paypal",
    defaultMessage: "PayPal",
  },
  noPaypal: {
    id: "paymentMethods.noPaypal",
    defaultMessage: "No PayPal",
  },
  paypalTransactionsAreNotSupportedForThisService: {
    id: "paymentMethods.paypalTransactionsAreNotSupportedForThisService",
    defaultMessage:
      "PayPal transactions are not supported for this service",
  },
  submit: {
    id: "configurePreferredPaymentMethod.submit",
    defaultMessage: "Submit",
  },
});
